var _require = require('../../../../../lib/saito/ui/saito-file-drop/saito-file-drop.template'),
  saitoFileDropOverlay = _require.saitoFileDropOverlay;
module.exports = function (app, mod) {
  var progressHtml = "\n    <div class=\"state\" hidden>\n      <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n      <div class=\"instructions status\">Preparing upload\u2026</div>\n      <div class=\"loader\" aria-hidden=\"true\"></div>\n    </div>\n  ";
  return saitoFileDropOverlay({
    title: 'Upload ROM',
    prompt: 'Drag and drop a ROM you have legal access to',
    dropzoneId: 'nwasm-upload-rom',
    rootClass: 'nwasm-upload-rom',
    extraBodyHtml: progressHtml
  });
};